import React from 'react'
import { useTranslation } from 'react-i18next'
import { Information, TextMedium } from '../styles'
import moment from 'moment'

const Element = ({ data = {} }) => {
  const { t } = useTranslation()

  const { finishedAt, screenerFinishedAt } = data

  return (
    <React.Fragment>
      <Information>
        <label>{t('components.enrollmentInformation.finishedAt')}</label>
        <TextMedium>
          {finishedAt ? moment(finishedAt).format('YYYY-MM-DD HH:mm') : 'N/A'}
        </TextMedium>
      </Information>

      <Information>
        <label>
          {t('components.enrollmentInformation.screenerFinishedAt')}
        </label>
        <TextMedium>
          {screenerFinishedAt
            ? moment(screenerFinishedAt).format('YYYY-MM-DD HH:mm')
            : 'N/A'}
        </TextMedium>
      </Information>
    </React.Fragment>
  )
}

export default Element
